import React from "react";
import {Redirect} from "react-router-dom";

// Layout Types
import {DefaultLayout} from "./layouts";

// Route Views
import BlogOverview from "./views/BlogOverview";
import UserProfileLite from "./views/UserProfileLite";
import AddNewPost from "./views/AddNewPost";
import Errors from "./views/Errors";
import ComponentsOverview from "./views/ComponentsOverview";
import Tables from "./views/Tables";
import AboutPage from "./views/AboutPage";
import GamesPage from "./views/GamesPage";
import EmbededPage from "./views/EmbededPage";
import KrisKrosPage from "./views/KrisKrosPage";
import SlovniFotbalPage from "./views/SlovniFotbalPage";
import DobyvatelPage from "./views/DobyvatelPage";
import TankyPage from "./views/TankyPage";
import WelcomePage from "./views/WelcomePage";
import AdminPage from "./views/AdminPage";
import { ADMIN_PATH } from "./utils/secretSearch";

export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/hry"/>
  },
  {
    path: "/blog-overview",
    layout: DefaultLayout,
    component: BlogOverview
  },
  {
    path: "/user-profile-lite",
    layout: DefaultLayout,
    component: UserProfileLite
  },
  {
    path: "/add-new-post",
    layout: DefaultLayout,
    component: AddNewPost
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors
  },
  {
    path: "/components-overview",
    layout: DefaultLayout,
    component: ComponentsOverview
  },
  {
    path: "/info",
    layout: DefaultLayout,
    component: AboutPage
  },
  {
    path: "/hry",
    layout: DefaultLayout,
    component: GamesPage
  },
  {
    path: "/uvod",
    layout: DefaultLayout,
    component: WelcomePage
  },
  {
    path: "/embeded/:id",
    layout: DefaultLayout,
    component: EmbededPage
  },
  {
    path: "/kriskros",
    layout: DefaultLayout,
    component: KrisKrosPage
  },
  {
    path: "/slovnifotbal",
    layout: DefaultLayout,
    component: SlovniFotbalPage
  },
  {
    path: "/dobyvatel",
    layout: DefaultLayout,
    component: DobyvatelPage
  },
  {
    path: "/tanky",
    layout: DefaultLayout,
    component: TankyPage
  },
  {
    // Deliberately missing from the sidebar - you get here by typing the secret
    // word into the search box, see utils/secretSearch.
    path: ADMIN_PATH,
    layout: DefaultLayout,
    component: AdminPage
  },
];
